import IntellachatMessages from "./Messages/IntellachatMessages";
import IntellachatInput from "../../Components/Inputs/IntellachatInput";
import ChatHistorySidebar from "./Sidebar/ChatHistorySidebar";
import { useChat } from "../../Context/ChatContext";
import { useState } from "react";

const IntellachatPage = () => {
  const { chatMessages } = useChat();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="relative h-full bg-dark-bg">
      {/* Sidebar */}
      <ChatHistorySidebar
        isCollapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      {/* Main Chat Area */}
      <div className="h-full flex flex-col pl-12">
        {/* Chat Area */}
        <div className="flex-1 flex flex-col items-center justify-center px-4 overflow-hidden">
          {chatMessages.length === 0 ? (
            /* Empty State - Centered Content */
            <div className="flex flex-col items-center justify-center w-full max-w-3xl">
              <h1 className="text-4xl font-semibold text-white mb-8">
                What can I help with?
              </h1>
              <div className="w-full">
                <IntellachatInput />
              </div>
            </div>
          ) : (
            /* Chat with Messages */
            <div className="flex flex-col w-full h-full">
              <div className="flex-1 overflow-y-auto w-full">
                <div className="max-w-3xl mx-auto px-4">
                  <IntellachatMessages />
                </div>
              </div>
              <div className="flex-shrink-0 pb-4 w-full">
                <div className="max-w-3xl mx-auto">
                  <IntellachatInput />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer Disclaimer */}
        <div className="text-center py-3 text-xs text-gray-500">
          AI can make mistakes. Please double-check responses.
        </div>
      </div>
    </div>
  );
};

export default IntellachatPage;
